/* eslint-disable */
import configure from './configureStore'

export let store

export const configureStore = (...params) => {
  store = configure(...params)
  return store
}


// WEBPACK FOOTER //
// ./src/app/store/index.js